import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-10 scrollable-section" }
const _hoisted_2 = { class: "pt-16" }

import ButtonFixed from "@/components/custom/ButtonFixed.vue";
import Icon from "@/components/Icons/Icon.vue";
import {useRouter} from "vue-router";
import {computed, ref} from "vue";
import CreatedBy from "@/components/custom/CreatedBy.vue";
import HealthGoalForm from "@/views/ClientComponents/HealthGoals/Components/HealthGoalForm.vue";
import {healthGoalsService} from "@/api/services/healthGoals";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateHealthGoals',
  setup(__props) {

const router = useRouter();
const loading = ref(false);
const errors = ref(null);

const formState = ref({
  name: '',
  description: '',
  reason: '',
  timeframe_value: '',
  timeframe_unit: 'select',
  severity_rating: 0,
  status: null,
  is_complete: null
});

const disableSave = computed(() => {
  return !formState.value.name || !formState.value.description || !formState.value.reason || !formState.value.timeframe_value || !formState.value.timeframe_unit || !formState.value.severity_rating;
})

const onSave = () => {
  loading.value = true;
  healthGoalsService.create(formState.value)
      .then(() => {
        loading.value = false;
        router.push({name: 'health-goals'});
      })
      .catch((error) => {
        console.log(error);
        errors.value = error.response.data.errors
        loading.value = false;
      });
}

return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_container, { class: "px-0 pt-0 pb-5" }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "text-right px-4 pt-3",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'health-goals' })))
        }, [
          _createVNode(Icon, {
            color: "primaryColor",
            icon: "cross-icon"
          })
        ]),
        _createElementVNode("section", _hoisted_1, [
          _createVNode(CreatedBy),
          _createVNode(HealthGoalForm, {
            modelValue: formState.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formState).value = $event)),
            errors: errors.value
          }, null, 8, ["modelValue", "errors"])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(ButtonFixed, {
        "custom-class": ['text-white', {
          'primary-button': !disableSave.value,
          'grey-disable': disableSave.value || loading.value
        }],
        "custom-icon-class": "add-new-circle-icon",
        text: "Save",
        onClick: onSave
      }, null, 8, ["custom-class"])
    ])
  ], 64))
}
}

})